import { Platform } from 'react-native';

import { proxy } from '../../../../globalVars/data';
import { getCtData } from '../../../project';
import { Tstation } from '../MapRentActive';

export const getAllStations = async () => {
  const requestOptions: RequestInit = {
    method: 'GET',
    redirect: 'follow',
  };

  const urlWeb = proxy + 'http://200.234.207.52:8000/stations';
  const urlNative = `http://200.234.207.52:8000/stations`;

  const condNative = Platform.OS === 'web' ? urlWeb : urlNative;
  // console.log({ condNative });

  try {
    const response = await fetch(condNative, requestOptions);
    console.log({ response });

    // Se não for sucesso (2xx), retorna array vazio
    if (!response.ok) {
      console.log('GET ALL STATIONS ERROR', {
        status: response.status,
        statusText: response.statusText,
      });
      return [];
    }

    let json: Record<string, Tstation>;
    try {
      json = await response?.json();
    } catch (parseError) {
      console.log('GET ALL STATIONS ERROR - JSON Parse failed:', parseError);
      return [];
    }

    console.log({ json });

    // Validar que json é um objeto válido
    if (!json || typeof json !== 'object') {
      console.log('GET ALL STATIONS ERROR - Invalid data format');
      return [];
    }

    return Object.values(json);
  } catch (error) {
    console.log('GET ALL STATIONS ERROR - Exception:', error);
    return [];
  }
};
